
export const SNOWCAPPED_VERSION_ID = 7

export const DATA_VERSION = 4
export const IS_EXPERIMENTAL = false

export const IS_DEV = false